import { localStorage } from '@openclassrooms/utils/local-storage';

const getKeyData = async (storageKey) => {
  const localeStorageItem = await localStorage.getItem(storageKey);
  if (!localeStorageItem) return {};

  try {
    return JSON.parse(localeStorageItem);
  } catch (e) {
    return localeStorageItem;
  }
};

const getItem = async (storageKey, userId) => {
  const keyData = await getKeyData(storageKey);
  return keyData[userId];
};

const setLocalstorage = (storageKey, values) => localStorage.setItem(storageKey, values);

const setItem = async (storageKey, userId, values) => {
  const keyData = await getKeyData(storageKey);
  const newValues = {
    ...keyData,
    [userId]: values,
  };

  return setLocalstorage(storageKey, newValues);
};

const addItem = async (storageKey, userId, values) => {
  const keyData = await getKeyData(storageKey);
  const newValues = {
    ...keyData,
    [userId]: {
      ...keyData[userId],
      ...values,
    },
  };

  return setLocalstorage(storageKey, newValues);
};

const deleteItem = async (storageKey, userId) => {
  const keyData = await getKeyData(storageKey);
  const newValues = Object.keys(keyData).reduce((acc, item) => {
    if (item === userId.toString()) return acc;
    return {
      ...acc,
      [item]: keyData[item],
    };
  }, {});

  setLocalstorage(storageKey, newValues);
};

const deleteOtherUsersData = async (storageKey, userId) => {
  const keyData = await getKeyData(storageKey);

  if (!keyData) {
    return;
  }

  const newValues = { [userId]: keyData[userId] };

  setLocalstorage(storageKey, newValues);
};

export default {
  getItem,
  setItem,
  addItem,
  deleteItem,
  deleteOtherUsersData,
};
